import pino, { type Logger } from 'pino';

export type { Level, Logger } from 'pino';

const REDACT_PATHS = [
  'authorization',
  'password',
  'token',
  'secret',
  'apiKey',
  '*.authorization',
  '*.password',
  '*.token',
  '*.secret',
  '*.apiKey',
];

export interface CreateBrowserLoggerOptions {
  bindings?: Record<string, unknown>;
  /** Whether this is a development build. Pass `import.meta.env.DEV`. */
  dev?: boolean;
  level?: pino.Level;
}

/**
 * Builds the browser logger.
 *
 * pino ships a browser build that bundlers substitute via its `browser` field, so
 * this is the same API as the server — one logging interface to learn, not two.
 *
 * Defaults to warn in production: shipped code should not narrate itself into a
 * user's console, but real failures still need to surface.
 */
export function createBrowserLogger(
  options: CreateBrowserLoggerOptions = {},
): Logger {
  const { bindings, dev = false, level } = options;

  return pino({
    base: bindings,
    // asObject keeps fields inspectable in devtools instead of stringified.
    browser: { asObject: true },
    level: level ?? (dev ? 'debug' : 'warn'),
    redact: { censor: '[REDACTED]', paths: REDACT_PATHS },
  });
}
